import React from "react";
import PropTypes from "prop-types";
import jMoment2 from "moment-jalaali";
import jMoment from "components/classes/Jmomen";
import moment from "moment-jalaali";
import { Button, Dropdown, Menu, InputNumber, Row, Col } from "antd";
import MaterialIcon from "components/common/MaterialIcon";
import { Month } from "../Components";
import Mode from "./Base";

@autobind
/**
 *
 * @extends Mode
 */
export default class Monthly extends Mode {
  /**
   *
   * @return {Object}
   */
  static get propTypes() {
    return Object.assign({}, Mode.propTypes, {
      month: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      onChange: PropTypes.func,
      disabled: PropTypes.func,
    });
  }

  /**
   *
   * @return {Object}
   */
  static get defaultProps() {
    return Object.assign({}, Mode.defaultProps, {
      month: jMoment().jMonth(),
    });
  }

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = Object.assign({}, this._initialState, {
      month: props.month,
      holidays: this._getParsedHolidays(),
    });
  }

  componentDidMount() {
    window.addEventListener("storage", this._onStorageChange);
  }

  componentWillUnmount() {
    window.removeEventListener("storage", this._onStorageChange);
  }

  _onStorageChange = (event) => {
    if (event.key === "Holidays") {
      this.setState({ holidays: this._getParsedHolidays() });
    }
  };

  _getParsedHolidays() {
    const rawHolidays = localStorage.getItem("Holidays");
    return rawHolidays ? JSON.parse(rawHolidays) : [];
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    super.componentWillReceiveProps(np);

    if (this.props.month !== np.month) {
      this.setState({
        month: np.month,
      });
    }
  }

  /**
   *
   */
  get year() {
    return this.state.year;
  }

  /**
   *
   */
  get month() {
    return this.state.month;
  }

  /**
   *
   * @param {String} end
   * @private
   */
  _onMouseUp(end) {
    const { onChange, disabled } = this.props;

    if (!disabled(end)) {
      let selected = [
        {
          start: end,
          end,
        },
      ];

      this.setState(
        {
          selected,
        },
        () => onChange(selected)
      );
    }
  }

  /**
   *
   * @return {String}
   * @private
   */
  get _titleYear() {
    const { year } = this.state;
    /*
        <Dropdown
          key="year-select"
          getPopupContainer={() => document.getElementsByClassName("calendar") && document.getElementsByClassName("calendar")[0]}
          overlay={(
            <Menu
              onClick={({key}) => this.setState({year: key * 1})}
              selectedKeys={[`${year}`]}
              style={{
                maxHeight: 300,
                overflowY: "auto",
              }}
            >
              {
                Array.range(year + 10, year - 10).map((_year) =>
                  <Menu.Item key={`${_year}`}>
                    {_year}
                  </Menu.Item>,
                )
              }
            </Menu>
          )}
          trigger={["click"]}
        >
          <a className="ant-dropdown-link">
            {year} <MaterialIcon name="chevron-down"/>
          </a>
        </Dropdown>
     */
    return (
      <InputNumber
        key="year-select"
        style={{
          margin: "0px",
        }}
        onChange={(key) => {
          if (key > 1300) {
            this.setState({ year: key * 1 });
          }
        }}
        value={[`${year}`]}
      />
    );
  }

  /**
   *
   * @return {String}
   * @private
   */
  get _titleMonth() {
    const { year, month } = this.state;

    return (
      <Dropdown
        key="month-select"
        getPopupContainer={() =>
          document.getElementsByClassName("calendar") &&
          document.getElementsByClassName("calendar")[0]
        }
        overlay={
          <Menu
            onClick={({ key }) => this.setState({ month: key * 1 })}
            selectedKeys={[`${month}`]}
            style={{
              maxHeight: 300,
              overflowY: "auto",
            }}
          >
            {Array.range(11).map((_month) => (
              <Menu.Item key={`${_month}`}>
                {jMoment(`${year}-${_month + 1}`, "jYYYY-jM").format("jMMMM")}
              </Menu.Item>
            ))}
          </Menu>
        }
        trigger={["click"]}
      >
        <a
          className="ant-dropdown-link"
          style={{ width: 80, display: "inline-block" }}
        >
          {jMoment(`${year}-${month + 1}`, "jYYYY-jM").format("jMMMM")}{" "}
          <MaterialIcon name="chevron-down" />
        </a>
      </Dropdown>
    );
  }

  /**
   *
   * @return {String}
   * @private
   */
  get _title() {
    const { year, month } = this.state;
    {
      /*app.translate("main.Month")*/
    }
    return (
      <Row
        style={{
          width: "100%",
        }}
        key="year-month-select"
      >
        <Col
          sm={16}
          md={12}
          lg={16}
          style={{
            width: "170px",
          }}
        >
          {this._titleMonth} {this._titleYear}
        </Col>
        <Col
          sm={8}
          md={24}
          lg={8}
          style={{
            minWidth: "115px",
          }}
        >
          {this.extra}
        </Col>
      </Row>
    );
    // return `${jMoment(`${year}-${month + 1}`, "jYYYY-jM").format("jMMMM")} ${app.translate("main.Month")} ${year}`;
  }

  /**
   *
   * @return {XML}
   * @private
   */
  get extra() {
    const { year, month } = this.state;
    const { loading } = this.props;

    // noinspection RequiredAttributes
    return (
      <Button.Group>
        <Button
          type="primary"
          icon="left"
          style={{
            padding: 2,
          }}
          disabled={loading}
          onClick={() => {
            let _moment = jMoment2(`${year}-${month + 1}`, "jYYYY-jM").subtract(
              1,
              "jMonth"
            );

            this.setState({ year: _moment.jYear(), month: _moment.jMonth() });
          }}
        />
        <Button
          type="dashed"
          disabled={
            loading ||
            (year === jMoment().jYear() && month === jMoment().jMonth())
          }
          onClick={() => {
            this.setState({
              year: jMoment().jYear(),
              month: jMoment().jMonth(),
            });
          }}
        >
          {app.translate("main.Current Month")}
        </Button>
        <Button
          type="primary"
          icon="right"
          disabled={loading}
          style={{
            padding: 2,
          }}
          onClick={() => {
            let _moment = jMoment2(`${year}-${month + 1}`, "jYYYY-jM").add(
              1,
              "jMonth"
            );

            this.setState({ year: _moment.jYear(), month: _moment.jMonth() });
          }}
        />
      </Button.Group>
    );
  }

// متد کمکی برای تشخیص نوع تاریخ
isJalaliDate(dateString) {
  // تبدیل ارقام فارسی به انگلیسی
  const normalizedDate = dateString.replace(/[۰-۹]/g, (match) => {
    return String.fromCharCode(match.charCodeAt(0) - '۰'.charCodeAt(0) + '0'.charCodeAt(0));
  });
  
  // استخراج سال از تاریخ
  const yearMatch = normalizedDate.match(/^(\d{4})[-/]/);
  if (!yearMatch) return false;
  
  const year = parseInt(yearMatch[1], 10);
  
  // اگر سال بین 1300 تا 1450 باشد، احتمالاً شمسی است
  // اگر سال بین 1900 تا 2100 باشد، احتمالاً میلادی است
  if (year >= 1300 && year <= 1450) {
    return true; // شمسی
  } else if (year >= 1900 && year <= 2100) {
    return false; // میلادی
  }
  
  // برای سال‌های مبهم، بررسی بیشتر
  // اگر با 13 شروع می‌شود و کمتر از 1380 است، احتمالاً شمسی است
  if (year >= 1300 && year < 1380) {
    return true;
  }
  
  // پیش‌فرض: میلادی
  return false;
}

_holidays(year) {
  // تعریف اولیه از وضعیت‌ها
  const statuses = [...(this.props.statuses || [])];
  
  // تعریف تعطیلات نمونه برای سال درخواستی
  const defaultHolidays = [
    {
      "calendarDayTypeId": 2,
      "date": `${year}-01-01`,
      "description": "عید نوروز",
      "color": "#cc0000",
      "title": "روز تعطیل رسمی"
    },
    {
      "calendarDayTypeId": 2,
      "date": `${year}-01-02`,
      "description": "شهادت حضرت علی علیه السلام",
      "color": "#cc0000",
      "title": "روز تعطیل رسمی"
    },
    {
      "calendarDayTypeId": 2,
      "date": `${year}-01-03`,
      "description": "عید نوروز",
      "color": "#cc0000",
      "title": "روز تعطیل رسمی"
    },
    {
      "calendarDayTypeId": 2,
      "date": `${year}-01-04`,
      "description": "عید نوروز",
      "color": "#cc0000",
      "title": "روز تعطیل رسمی"
    },
    {
      "calendarDayTypeId": 2,
      "date": `${year}-01-12`,
      "description": "روز جمهوری اسلامی",
      "color": "#cc0000",
      "title": "روز تعطیل رسمی"
    },
    {
      "calendarDayTypeId": 2,
      "date": `${year}-01-13`,
      "description": "روز طبیعت",
      "color": "#cc0000",
      "title": "روز تعطیل رسمی"
    }
  ];

  // ترکیب تعطیلات از localStorage با تعطیلات پیش‌فرض
  let customHolidays = [];
  
  try {
    if (this.state.holidays && Array.isArray(this.state.holidays)) {
      // تبدیل تاریخ‌ها به فرمت استاندارد
      customHolidays = this.state.holidays
        .filter(item => item && item.date && item.calendarDayTypeId)
        .map(item => {
          // تبدیل تاریخ به فرمت استاندارد
          let date = item.date;
          
          // اگر تاریخ شامل timestamp باشد، آن را جدا می‌کنیم
          if (typeof date === 'string' && date.includes('T')) {
            date = date.split('T')[0];
          }
          
          // تبدیل تاریخ میلادی به شمسی اگر نیاز باشد
          if (!this.isJalaliDate(date)) {
            try {
              date = moment(date).format('jYYYY-jMM-jDD');
            } catch (e) {
              console.error('خطا در تبدیل تاریخ:', date);
            }
          }
          
          // ساختار جدید تعطیلات
          return {
            calendarDayTypeId: item.calendarDayTypeId,
            date: date,
            description: item.description || '',
            color: this._getColorByType(item.calendarDayTypeId),
            title: this._getTitleByType(item.calendarDayTypeId)
          };
        })
        .filter(item => {
          // فقط تعطیلات سال درخواستی را برمی‌گردانیم
          return item.date && item.date.startsWith(`${year}-`);
        });
    }
  } catch (error) {
    console.error('خطا در پردازش تعطیلات سفارشی:', error);
  }
  
  // ترکیب تعطیلات پیش‌فرض و سفارشی
  const allHolidays = [...defaultHolidays, ...customHolidays];
  
  // ادغام با statuses موجود
  allHolidays.forEach(holiday => {
    const idx = statuses.findIndex(s => s.date === holiday.date);
    
    if (idx > -1) {
      statuses[idx] = { ...statuses[idx], ...holiday };
    } else {
      statuses.push(holiday);
    }
  });

  return statuses;
}

// متدهای کمکی برای تعیین رنگ و عنوان بر اساس نوع روز
_getColorByType(calendarDayTypeId) {
  switch (parseInt(calendarDayTypeId)) {
    case 1: return "#00cc00"; // روز کاری
    case 2: return "#cc0000"; // روز تعطیل رسمی
    case 4: return "#ff9900"; // روز تعطیل شرکتی
    case 5: return "#00cccc"; // رمضان
    default: return "#999999"; // سایر
  }
}

_getTitleByType(calendarDayTypeId) {
  switch (parseInt(calendarDayTypeId)) {
    case 1: return "روز کاری";
    case 2: return "روز تعطیل رسمی";
    case 4: return "روز تعطیل شرکتی";
    case 5: return "رمضان";
    default: return "سایر";
  }
}
  /**
   *
   * @return {XML}
   * @private
   */
  get _component() {
    const { selected, year, month } = this.state;
    const { ...rest } = this.props;

    return (
      <Month
        {...rest.$omit(["onChange"])}
        onMouseUp={this._onMouseUp}
        selected={selected}
        year={year}
        month={month}
        title={false}
        statuses={this._holidays(year)}
      />
    );
  }
}

